import { StyleSheet, View } from 'react-native';

//import ScreenPermissions from './ScreenPermissions.jsx';

import AppConstants from '../AppConstants.js';
//import ScreenIntroduction from './ScreenIntroduction.jsx';
//import ScreenLobby from './ScreenLobby.jsx';
import { useJourney } from '../contexts/JourneyContext.js';
import CloudBackground from '../elements/CloudBackground.jsx';
import LoadingSpinner from '../elements/LoadingSpinner.jsx';
import MediaPlayerModal from '../elements/MediaPlayerModal.jsx';
import ScreenCoda from './ScreenCoda.jsx';
import ScreenFinale from './ScreenFInale.jsx';
import ScreenHunt from './ScreenHunt.jsx';
import ScreenOverture from './ScreenOverture';
import ScreenPermissions from './ScreenPermissions';
import ScreenPrelude from './ScreenPrelude.jsx';
import ScreenSignin from './ScreenSignin';

export default function ScreenMain() {
  const journeyContext = useJourney();


  // Styles
  const styles = StyleSheet.create({
    fullScreenContainer: {
      width: '100%',
      height: '100%',
    },
    centerContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    lobbyContainer: {
      flex: 1,
      backgroundColor: AppConstants.ulyssesColor,
    },
  });

    
  // Show loading spinner when any loading is happening
  if (journeyContext.isLoading || journeyContext.appPhase === "Loading") {
    return (
      <>
        <CloudBackground>
          <View style={styles.centerContainer}>
            <LoadingSpinner />
          </View>
        </CloudBackground>
        <MediaPlayerModal />
      </>
    );
  }
  
  let screenContent;  
  switch (journeyContext.appPhase) {
    case "Signin":
      screenContent = <ScreenSignin />;
      break;
    case 'Permissions':
      screenContent = <ScreenPermissions />;
      break;      
    case 'Prelude':
      screenContent = <ScreenPrelude />;
      break;
    case 'Overture':
      screenContent = <ScreenOverture />;
      break;      
    case 'Finale':
      screenContent = <ScreenFinale />;
      break;  
    case 'Coda':
      screenContent = <ScreenCoda />;
      break;
    case 'Hunt':
      screenContent = <ScreenHunt />;
      break;      
    default:
      // Fallback loading state if no phase matches
      screenContent = (
        <CloudBackground>
          <View style={styles.centerContainer}>
            
          </View>
        </CloudBackground>
      );
      break;
  }

  return (
    <>
      {screenContent}
      <MediaPlayerModal />
    </>
  );      
}
